import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Trophy } from "lucide-react";

/** Games polish — compact Top-3 chip after each Trivia reveal.
 * Recognition only (no coins/wallet). Auto-dismisses after 8s. */
export default function TriviaTopChip({ streamId, trigger }) {
  const [entries, setEntries] = useState([]);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!trigger) return undefined;
    let gone = false;
    api.get(`/live/${streamId}/leaderboard`)
      .then(({ data }) => {
        if (gone || !data.entries?.length) return;
        setEntries(data.entries.slice(0, 3));
        setVisible(true);
      })
      .catch(() => {});
    const t = setTimeout(() => setVisible(false), 8000);
    return () => { gone = true; clearTimeout(t); };
  }, [trigger, streamId]);

  if (!visible || !entries.length) return null;
  const medals = ["🥇", "🥈", "🥉"];
  return (
    <div
      data-testid="trivia-top-chip"
      className="pointer-events-none flex items-center gap-2 h-8 px-3 bg-black/55 backdrop-blur-md border border-yellow-400/30 rounded-full text-white text-xs animate-in fade-in slide-in-from-top-2"
    >
      <Trophy size={12} className="text-yellow-300 shrink-0" />
      {entries.map((e, i) => (
        <span key={e.user_id} className="whitespace-nowrap">
          {medals[i]} {e.user?.display_name || "?"} <span className="text-yellow-300 tabular-nums">{e.points}</span>
        </span>
      ))}
    </div>
  );
}
